import { render, staticRenderFns } from "./itemBody.vue?vue&type=template&id=1cf60848&scoped=true&"
import script from "./itemBody.vue?vue&type=script&lang=js&"
export * from "./itemBody.vue?vue&type=script&lang=js&"
import style0 from "./itemBody.vue?vue&type=style&index=0&id=1cf60848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf60848",
  null
  
)

export default component.exports